<div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/detalii.jpg')"
>
  <h3
    class="title"
  >
    Living by nature
  </h3>
</div>

<div
  class="container"
>
  <p
    class="downtown-description"
  >
    <ng-template ngFor let-paragraph [ngForOf]="newArray(items.length)">
      <img
        class="title-decoration"
        src="/assets/icons/lifestyle/frunza.svg"
      >
      <h5
        class="title"
        [innerHTML]="'pages.downtown_life.technical.' + paragraph + '.title' | translate"
      >
      </h5>
      <ul>
        <li
          *ngFor="let item of newArray(items[paragraph])"
          translate
        >
          pages.downtown_life.technical.{{ paragraph }}.items.{{ item }}
        </li>
      </ul>
    </ng-template>
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/technical.component.html